export default "__VITE_ASSET__CQabkDqY__"